import React from "react";
import { FormattedMessage } from "react-intl";
import StyledLink from "../StyledLink/StyledLink";

import "./topFooter.scss";
const TopFooter = () => {
  return (
    <div className="topFooter">
      <div className="bg"></div>
      <div className="text">
        <h1 className="mid-title">
          <FormattedMessage
            id="top-footer-title"
            defaultMessage="What are you waiting for?"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="top-footer-text"
            defaultMessage="Find out how to drive quality leads with lucrative ad formats and total audience coverage"
          />
        </p>

        <StyledLink
          to="/"
          styles="styled1"
          linkName={
            <FormattedMessage id="join-now" defaultMessage="Join now" />
          }
        />
      </div>
    </div>
  );
};

export default TopFooter;
